import { Component, OnInit } from '@angular/core';
import { HeaderService, Header } from '../../common/header/header.service';
import { FooterService, Footer } from '../../common/footer/footer.service';
import { LoaderService, Loader } from '../../common/loader/loader.service';
import { ApplicationService } from '../../application/application.service';
import { Application } from '../../application/application';
import { JuspayService } from './juspay.service';
import { IframeElement, PaymentMethod } from './juspay';
import { Router, ActivatedRoute } from '@angular/router';
import { DownpaymentService } from '../down-payment/down-payment.service';

declare var $: any;
declare var window: any;
declare var Juspay: any;

@Component({
  selector: 'zest-juspay',
  templateUrl: './juspay.component.html',
  styleUrls: ['./juspay.component.scss']
})
export class JuspayComponent implements OnInit {

  public activeTab;
  public addNewCard;
  public availableBanks = [];
  public recommendedBanks = [];
  public savedCards = [];
  public downPayment = 0;
  public selectedCard = 0;
  public orderId;
  public cardNumberError = false;
  public cardMonthError = false;
  public cardYearError = false;
  public cardCVVError = false;
  public cardNameError = false;
  public cardErrorMsg = '';
  public paymentMethod = PaymentMethod.Card;
  public selectedBank = '';
  public application: Application;
  public isMobile: boolean;
  public juspayStyle;
  public jusPaySavedCardStyle;
  public errorMsg: String;
  public emptyFormError = false;
  public formSubmitted = false;
  public processingNB = false;
  public errorMap = {
    cardNumber: { empty: true, invalid: null },
    cardName: { empty: true, invalid: null },
    cardMonth: { empty: true, invalid: null },
    cardYear: { empty: true, invalid: null },
    cardCvv: { empty: true, invalid: null }
  };
  public errorMapSavedCard = {
    cardCvv: { empty: true, invalid: null }
  };
  public id: number;

  constructor(
    private headerService: HeaderService,
    private footerService: FooterService,
    private loaderService: LoaderService,
    private juspayService: JuspayService,
    private applicationService: ApplicationService,
    private downpaymentService: DownpaymentService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.loaderService.ShowLoaderSource.next(new Loader(true, ''));
    this.route.queryParams.subscribe(value => {
      if (value.error === 'true') {
        this.errorMsg = 'Transaction failed, please try again here. We have also sent you a link to pay via email and sms.';
      }
    });
    this.getApplication();
    this.createOrder();
    this.getDownPaymentStatus();
    this.getJuspayStyle();
    this.getBankList();
    this.getSavedCards();
    this.initJuspayPlugin();
    this.hideLoader();
    this.downPayment = this.application.DownpaymentAmount + this.application.ProcessingFee;
    // this.downPayment=1;
    $('.collapsible').collapsible();
    this.headerService.ShowHeaderSource.next(new Header(1, true, 100, true, 'Downpayment', false));
    this.footerService.ShowFooterSource.next(new Footer(true, false, false, false, false, true));
    this.activeTab = 1;
    this.selectedCard = 0;
    this.orderId = '';
    this.addNewCard = false;
    // window.mobilecheck = ()=> {
    //  this.isMobile = false;
    //  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) this.isMobile = true;})(navigator.userAgent||navigator.vendor||window.opera);
    //  return this.isMobile;
    // };
    // if(this.isMobile){
    if (typeof window.Juspay !== 'undefined' && this.juspayStyle !== 'undefined') {
      setTimeout(() => {
        this.initJuspayForDebitCardMobileView();
        this.initNetBankingMobileView();
        // }
        // else {
        this.initJuspayForDebitCard();
        this.initNetBankingWeb();
      }, 500);
    }
    // }
  }
  hideLoader() {
    setTimeout(() => {
      this.loaderService.ShowLoaderSource.next(new Loader(false, ''));
    }, 2000);
  }
  initJuspayPlugin() {
    if (typeof Juspay === 'undefined') {
      setTimeout(() => {
        this.initJuspayPlugin();
      }, 500);
      return;
    } else {
      Juspay = window.Juspay;
    }
  }
  getJuspayStyle() {
    this.juspayService.getJuspayStyle().subscribe(response => {
      this.juspayStyle = response.style;
      this.jusPaySavedCardStyle = response.savedCard;
    });
  }
  initForSavedCards() {
    this.initSavedCardsWeb();
    this.initSavedCardsMobileView();
  }
  selectTab(id) {
    this.activeTab = id;
    this.errorMap = {
      cardNumber: { empty: true, invalid: null },
      cardName: { empty: true, invalid: null },
      cardMonth: { empty: true, invalid: null },
      cardYear: { empty: true, invalid: null },
      cardCvv: { empty: true, invalid: null }
    };
    this.errorMapSavedCard = {
      cardCvv: { empty: true, invalid: null }
    };
    if (id === 3) {
      this.paymentMethod = PaymentMethod.NetBanking;
    } else {
      this.paymentMethod = PaymentMethod.Card;
    }
  }
  selectedSavedCard(i) {
    this.selectedCard = i;
  }
  addNewCardFn(id) {
    this.selectedCard = undefined;
    if (id === 1 || id === 2) {
      this.paymentMethod = PaymentMethod.Card;
    } else {
      this.paymentMethod = PaymentMethod.NetBanking;
    }
    if (this.addNewCard) {
      this.addNewCard = false;
    } else {
      this.addNewCard = true;
    }
    this.errorMap = {
      cardNumber: { empty: true, invalid: null },
      cardName: { empty: true, invalid: null },
      cardMonth: { empty: true, invalid: null },
      cardYear: { empty: true, invalid: null },
      cardCvv: { empty: true, invalid: null }
    };
    this.errorMapSavedCard = {
      cardCvv: { empty: true, invalid: null }
    };
  }
  createOrder() {
    this.downpaymentService.createOrder(this.application.ApplicationId).subscribe(response => {
      this.orderId = response.orderId;
    }, error => {
      // console.log('Transaction failed. Please try again.');
    });
  }
  getApplication() {
    this.application = this.applicationService.getApplication();
  }
  getBankList() {
    this.juspayService.getBankList().subscribe(response => {
      this.availableBanks = response;
      this.recommendedBanks = this.availableBanks.filter(availableBank => (
        availableBank.paymentMethod === 'NB_SBI' ||
        availableBank.paymentMethod === 'NB_AXIS' ||
        availableBank.paymentMethod === 'NB_DUMMY' ||
        availableBank.paymentMethod === 'NB_HDFC' ||
        availableBank.paymentMethod === 'NB_ICICI' ||
        availableBank.paymentMethod === 'NB_KOTAK'
      ));
      this.recommendedBanks.forEach(recommendedBank => {
        if (recommendedBank.paymentMethod === 'NB_SBI') {
          recommendedBank.label = 'SBI';
          recommendedBank.image = 'Sbi.png';
        } else if (recommendedBank.paymentMethod === 'NB_AXIS' || recommendedBank.paymentMethod === 'NB_DUMMY') {
          recommendedBank.label = 'AXIS';
          recommendedBank.image = 'Axis.png';
        } else if (recommendedBank.paymentMethod === 'NB_HDFC') {
          recommendedBank.label = 'HDFC';
          recommendedBank.image = 'Hdfc.png';
        } else if (recommendedBank.paymentMethod === 'NB_ICICI') {
          recommendedBank.label = 'ICICI';
          recommendedBank.image = 'Icici.png';
        } else if (recommendedBank.paymentMethod === 'NB_KOTAK') {
          recommendedBank.label = 'KOTAK';
          recommendedBank.image = 'Kotak.png';
        }
      });
    });
  }
  getSavedCards() {
    this.juspayService.getSavedCards().subscribe(response => {
      this.savedCards = response;
      if (this.savedCards.length > 0) {
        setTimeout(() => {
          this.initForSavedCards();
        }, 500);
      } else {
        this.activeTab = 2;
        $('._mobile-view').collapsible('open', 0);
        $('._add-new-card').click();
      }
    });
  }
  getDownPaymentStatus() {
    if (this.application) {
      this.downpaymentService.getDownPaymentStatus(this.application.ApplicationId).subscribe(response => {
        if ((response.PaymentOption === 'Electronic' && response.PaidOn !== null)) {
          this.application.IsDPMade = true;
          this.application.PaymentMode = response.PaymentOption;
          this.applicationService.saveApplication(this.application);
          this.applicationService.goToNextRoute(this.router.url);
        } else {
          this.application.IsDPMade = false;
          this.applicationService.saveApplication(this.application);
        }
      }, error => {
        this.application.IsDPMade = false;
        this.applicationService.saveApplication(this.application);
      });
    }
  }
  gotToPrevStep() {
    this.router.navigate(['/application/downpayment']);
  }
  initJuspayForDebitCard() {
    Juspay.Setup({
      payment_form: '#payment_form_debit_card',
      success_handler: function (status, statusObj) {
        window.top.location.href = statusObj.returnUrl;
      },
      error_handler: function (error_code, error_message,
        bank_error_code, bank_error_message, gateway_id, statusObj) {
        window.top.location.href = statusObj.returnUrl;
      },
      second_factor_window_closed_handler: function () {
        $('#common_pay_btn').removeAttr('disabled').removeClass('disabled');
      },
      iframe_elements: {
        card_number: {
          container: IframeElement.card_number,
          attributes: {}
        },
        name_on_card: {
          container: IframeElement.card_name,
          attributes: {}
        },
        card_exp_month: {
          container: IframeElement.expiry_month,
          attributes: {
            placeholder: 'MM'
          }
        },
        card_exp_year: {
          container: IframeElement.expiry_year,
          attributes: {
            placeholder: 'YY'
          }
        },
        security_code: {
          container: IframeElement.cvv,
          attributes: {}
        }
      },
      styles: this.juspayStyle,

      iframe_element_callback: (eventObj) => {
        this.errorCallBackFunction(eventObj);
      }
    });
  }
  initJuspayForDebitCardMobileView() {
    Juspay.Setup({
      payment_form: '#debit-card-m',
      success_handler: function (status, statusObj) {
        window.top.location.href = statusObj.returnUrl;
      },
      error_handler: function (error_code, error_message,
        bank_error_code, bank_error_message, gateway_id, statusObj) {
        window.top.location.href = statusObj.returnUrl;
      },
      second_factor_window_closed_handler: function () {
        $('#common_pay_btn').removeAttr('disabled').removeClass('disabled');
      },
      iframe_elements: {
        card_number: {
          container: IframeElement.card_number,
          attributes: {}
        },
        name_on_card: {
          container: IframeElement.card_name,
          attributes: {}
        },
        card_exp_month: {
          container: IframeElement.expiry_month,
          attributes: {
            placeholder: 'MM'
          }
        },
        card_exp_year: {
          container: IframeElement.expiry_year,
          attributes: {
            placeholder: 'YY'
          }
        },
        security_code: {
          container: IframeElement.cvv,
          attributes: {}
        }
      },
      styles: this.juspayStyle,
      iframe_element_callback: (eventObj) => {
        this.errorCallBackFunction(eventObj);
        // });
      }
    });
  }
  initNetBankingWeb() {
    Juspay.Setup({
      payment_form: '#netbanking-form-web',
      success_handler: function (status, statusObj) {
        window.top.location.href = statusObj.returnUrl;
      },
      error_handler: function (error_code, error_message,
        bank_error_code, bank_error_message, gateway_id, statusObj) {
        window.top.location.href = statusObj.returnUrl;
      },
      second_factor_window_closed_handler: function () {
        $('#common_pay_btn').removeAttr('disabled').removeClass('disabled');
      },
      iframe_elements: {
      },
      styles: {
        'input': {},
        ':focus': {
          'outline': 'none'
        }
        /* close commented backslash hack */
      },
      iframe_element_callback: (eventObj) => {
        this.errorCallBackFunction(eventObj);
      }
    });
  }
  initNetBankingMobileView() {
    Juspay.Setup({
      payment_form: '#netbanking-m',
      success_handler: function (status, statusObj) {
        window.top.location.href = statusObj.returnUrl;
      },
      error_handler: function (error_code, error_message,
        bank_error_code, bank_error_message, gateway_id, statusObj) {
        window.top.location.href = statusObj.returnUrl;
      },
      second_factor_window_closed_handler: function () {
        $('#common_pay_btn').removeAttr('disabled').removeClass('disabled');
      },
      iframe_elements: {
      },
      styles: {
        'input': {},
        ':focus': {
          'outline': 'none'
        }
      },
      iframe_element_callback: (eventObj) => {
        this.errorCallBackFunction(eventObj);
      }
    });
  }
  initSavedCardsWeb() {
    for (let i = 0; i < this.savedCards.length; i++) {
      Juspay.Setup({
        payment_form: '#saved_card_form-' + i,
        success_handler: function (status, statusObj) {
          window.top.location.href = statusObj.returnUrl;
        },
        error_handler: function (error_code, error_message,
          bank_error_code, bank_error_message, gateway_id, statusObj) {
          window.top.location.href = statusObj.returnUrl;
        },
        second_factor_window_closed_handler: function () {
          $('#common_pay_btn').removeAttr('disabled').removeClass('disabled');
        },
        iframe_elements: {
          security_code: {
            container: IframeElement.cvv,
            attributes: {
              placeholder: 'Enter CVV'
            }
          }
        },
        styles: this.jusPaySavedCardStyle,
        iframe_element_callback: (eventObj) => {
          this.errorCallBackFunctionSavedCard(eventObj);
          // if (eventObj.empty) {
        }
      });
    }
  }
  initSavedCardsMobileView() {
    for (let i = 0; i < this.savedCards.length; i++) {
      Juspay.Setup({
        payment_form: '#saved_card_form-m-' + i,
        success_handler: function (status, statusObj) {
          window.top.location.href = statusObj.returnUrl;
        },
        error_handler: function (error_code, error_message,
          bank_error_code, bank_error_message, gateway_id, statusObj) {
          window.top.location.href = statusObj.returnUrl;
        },
        second_factor_window_closed_handler: function () {
          $('#common_pay_btn').removeAttr('disabled').removeClass('disabled');
        },
        iframe_elements: {
          security_code: {
            container: IframeElement.cvv,
            attributes: {
              placeholder: 'CVV'
            }
          }
        },
        styles: this.jusPaySavedCardStyle,
        iframe_element_callback: (eventObj) => {
          this.errorCallBackFunctionSavedCard(eventObj);
        }
      });
    }
  }
  submitSavedCardForm(event, id, view) {
    this.id = id;
    for (const key in this.errorMapSavedCard) {
      if (this.errorMapSavedCard.hasOwnProperty(key)) {
        const value = this.errorMapSavedCard[key];
        // Use `key` and `value`
        if (value.empty === true || value.invalid === true) {
          value.invalid = true;
        } else {
          value.invalid = false;
        }
      }
    }
    if (id !== undefined) {
      if (view === 'mob') {
        $('#saved_card_form-m-' + id).submit();
      } else {
        $('#saved_card_form-' + id).submit();
      }
    }
    if (!this.errorMapSavedCard.cardCvv.empty && !this.errorMapSavedCard.cardCvv.invalid) {
      this.submitform(event);
    }
  }
  submitNBForm(event) {
    // this.formSubmitted = true;
    this.processingNB = true;
    this.submitform(event);
  }
  submitform(event) {
    this.toggleLoadingClass(event, true);
    this.formSubmitted = true;
    // this.processingNB = true;
    let error = false;
    for (const key in this.errorMap) {
      if (this.errorMap.hasOwnProperty(key)) {
        const value = this.errorMap[key];
        // Use `key` and `value`
        if (value.empty === true || value.invalid === true) {
          value.invalid = true;
          error = true;
        } else {
          value.invalid = false;
        }
      }

    }
    if (error === true) {
      // this.processingNB = false;
      if (this.id === undefined) {
        this.toggleLoadingClass(event, this.processingNB);
      }
    }
    if (this.errorMap.cardCvv.invalid && this.errorMap.cardMonth.invalid && this.errorMap.cardName.invalid && this.errorMap.cardNumber.invalid && this.errorMap.cardYear.invalid) {
      if (this.formSubmitted && this.id === undefined) {
        // this.loaderService.ShowLoaderSource.next(new Loader(true, ''));
        this.toggleLoadingClass(event, this.processingNB);
      }
    }
  }
  errorCallBackFunction(event) {
    this.errorMapSavedCard = {
      cardCvv: { empty: true, invalid: null }
    };
    this.emptyFormError = false;
    if (this.formSubmitted) {
      if (event.empty) {
        this.emptyFormError = true;
        // this.processingNB = false;
      } else {
        this.emptyFormError = false;
        // this.processingNB = true;
      }
    }
    if (event.empty) {
      switch (event.target_element) {
        case 'card_number':
          this.errorMap.cardNumber.empty = true;
          break;
        case 'card_exp_month':
          this.errorMap.cardMonth.empty = true;
          break;
        case 'card_exp_year':
          this.errorMap.cardYear.empty = true;
          break;
        case 'security_code':
          this.errorMap.cardCvv.empty = true;
          break;
        case 'name_on_card':
          this.errorMap.cardName.empty = true;
          break;
      }
    }
    if (!event.empty && !event.valid) {
      this.emptyFormError = false;
      this.formSubmitted = false;
      // this.processingNB = false;
      // this.showLoader();
      switch (event.target_element) {
        case 'card_number':
          this.errorMap.cardNumber.invalid = true;
          this.errorMap.cardNumber.empty = false;
          break;
        case 'card_exp_month':
          this.errorMap.cardMonth.invalid = true;
          this.errorMap.cardMonth.empty = false;
          break;
        case 'card_exp_year':
          this.errorMap.cardYear.invalid = true;
          this.errorMap.cardYear.empty = false;
          break;
        case 'security_code':
          this.errorMap.cardCvv.invalid = true;
          this.errorMap.cardCvv.empty = false;
          break;
        case 'name_on_card':
          this.errorMap.cardName.invalid = true;
          this.errorMap.cardName.empty = false;
          break;
      }
    }
    if (event.valid) {
      this.emptyFormError = false;
      switch (event.target_element) {
        case 'card_number':
          this.errorMap.cardNumber.invalid = false;
          this.errorMap.cardNumber.empty = false;
          break;
        case 'card_exp_month':
          this.errorMap.cardMonth.invalid = false;
          this.errorMap.cardMonth.empty = false;
          break;
        case 'card_exp_year':
          this.errorMap.cardYear.invalid = false;
          this.errorMap.cardYear.empty = false;
          break;
        case 'security_code':
          this.errorMap.cardCvv.empty = false;
          this.errorMap.cardCvv.invalid = false;
          break;
        case 'name_on_card':
          this.errorMap.cardName.invalid = false;
          this.errorMap.cardName.empty = false;
          break;
      }
    }
    if (event.partially_valid) {
      // console.log(event.target_element + ': Partially valid input.');
    }
    if (event.card_brand) {
      // console.log(event.target_element + ': ' + event.card_brand);
    }
    if (event.card_isin) {
      // console.log(event.target_element + ': ' + event.card_isin);
    }
  }
  errorCallBackFunctionSavedCard(event) {
    this.errorMap = {
      cardNumber: { empty: true, invalid: null },
      cardName: { empty: true, invalid: null },
      cardMonth: { empty: true, invalid: null },
      cardYear: { empty: true, invalid: null },
      cardCvv: { empty: true, invalid: null }
    };
    this.emptyFormError = false;
    if (this.formSubmitted) {
      if (event.empty) {
        this.emptyFormError = true;
      } else {
        this.emptyFormError = false;
      }
    }
    if (event.empty) {
      this.errorMapSavedCard.cardCvv.empty = true;

    }
    if (!event.empty && !event.valid) {
      this.emptyFormError = false;
      this.formSubmitted = false;
      this.errorMapSavedCard.cardCvv.invalid = true;
      this.errorMapSavedCard.cardCvv.empty = false;
    }
    if (event.valid) {
      this.emptyFormError = false;
      this.errorMapSavedCard.cardCvv.empty = false;
      this.errorMapSavedCard.cardCvv.invalid = false;
    }
    if (event.partially_valid) {
      // console.log(event.target_element + ': Partially valid input.');
    }
    if (event.card_brand) {
      // console.log(event.target_element + ': ' + event.card_brand);
    }
    if (event.card_isin) {
      // console.log(event.target_element + ': ' + event.card_isin);
    }
  }
  toggleLoadingClass(event, toggle) {
    if (toggle) {
      $(event.target).addClass('loading');
    } else {
      $(event.target).removeClass('loading');
    }
  }

}
